import React, { useState, useEffect } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, MenuItem, Tabs, Tab, InputAdornment, Dialog,
    DialogTitle, DialogContent, DialogActions, Stepper, Step, StepLabel,
    LinearProgress, Divider
} from '@mui/material';
import {
    Search as SearchIcon, Download as DownloadIcon,
    PersonAdd as PersonAddIcon, School as SchoolIcon,
    CheckCircle as CheckIcon, HourglassEmpty as PendingIcon,
    Cancel as CancelIcon, Visibility as ViewIcon
} from '@mui/icons-material';
import api from '../services/api';
import { toast } from 'react-toastify';

const OnlineAdmission = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [classFilter, setClassFilter] = useState('');
    const [viewDialog, setViewDialog] = useState(false);
    const [selectedApp, setSelectedApp] = useState(null);

    useEffect(() => { fetchApplications(); }, []);

    const fetchApplications = async () => {
        try {
            const res = await api.get('/admissions');
            setApplications(res.data.data || []);
        } catch (error) {
            setApplications([
                { id: 1, appNo: 'ONL/2026/001', studentName: 'Arjun Mehta', parentName: 'Suresh Mehta', phone: '9876543210', email: 'suresh@email.com', class: 'Class 1', dob: '2020-05-15', gender: 'Male', category: 'OPEN', previousSchool: 'ABC School', step: 3, status: 'Under Review', appliedDate: '2026-02-01', documents: ['Birth Certificate', 'Aadhaar', 'Previous TC'] },
                { id: 2, appNo: 'ONL/2026/002', studentName: 'Kavya Joshi', parentName: 'Ramesh Joshi', phone: '9876543211', email: 'ramesh@email.com', class: 'LKG', dob: '2021-08-22', gender: 'Female', category: 'OBC', previousSchool: '-', step: 4, status: 'Approved', appliedDate: '2026-01-28', documents: ['Birth Certificate', 'Aadhaar'] },
                { id: 3, appNo: 'ONL/2026/003', studentName: 'Siddharth Patil', parentName: 'Anil Patil', phone: '9876543212', email: 'anil@email.com', class: 'Class 5', dob: '2015-03-10', gender: 'Male', category: 'SC', previousSchool: 'XYZ School', step: 2, status: 'Documents Pending', appliedDate: '2026-02-05', documents: ['Birth Certificate'] },
                { id: 4, appNo: 'ONL/2026/004', studentName: 'Riya Shah', parentName: 'Nitin Shah', phone: '9876543213', email: 'nitin@email.com', class: 'UKG', dob: '2021-11-05', gender: 'Female', category: 'OPEN', previousSchool: '-', step: 1, status: 'Form Submitted', appliedDate: '2026-02-10', documents: [] },
                { id: 5, appNo: 'ONL/2026/005', studentName: 'Vivaan Kulkarni', parentName: 'Manoj Kulkarni', phone: '9876543214', email: 'manoj@email.com', class: 'Class 3', dob: '2017-01-20', gender: 'Male', category: 'NT', previousSchool: 'DEF School', step: 5, status: 'Admitted', appliedDate: '2026-01-15', documents: ['Birth Certificate', 'Aadhaar', 'Previous TC', 'Photos'] },
                { id: 6, appNo: 'ONL/2026/006', studentName: 'Aarya Desai', parentName: 'Vikram Desai', phone: '9876543215', email: 'vikram@email.com', class: 'Class 8', dob: '2012-07-30', gender: 'Female', category: 'OPEN', previousSchool: 'GHI School', step: 0, status: 'Rejected', appliedDate: '2026-02-08', documents: ['Birth Certificate'] },
            ]);
        } finally {
            setLoading(false);
        }
    };

    const filteredApps = applications.filter(a => {
        const matchTab = tab === 0 ? true : tab === 1 ? a.status === 'Approved' || a.status === 'Admitted' : tab === 2 ? a.status !== 'Approved' && a.status !== 'Admitted' && a.status !== 'Rejected' : a.status === 'Rejected';
        const matchClass = !classFilter || a.class === classFilter;
        const matchSearch = !searchTerm || a.studentName.toLowerCase().includes(searchTerm.toLowerCase()) || a.appNo.toLowerCase().includes(searchTerm.toLowerCase());
        return matchTab && matchClass && matchSearch;
    });

    const approvedCount = applications.filter(a => a.status === 'Approved' || a.status === 'Admitted').length;
    const pendingCount = applications.filter(a => a.status !== 'Approved' && a.status !== 'Admitted' && a.status !== 'Rejected').length;
    const rejectedCount = applications.filter(a => a.status === 'Rejected').length;

    const admissionSteps = ['Form Submitted', 'Documents Upload', 'Documents Verified', 'Under Review', 'Approved', 'Admitted'];

    const getStatusColor = (s) => {
        if (s === 'Approved' || s === 'Admitted') return 'success';
        if (s === 'Rejected') return 'error';
        return 'warning';
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonAddIcon sx={{ color: '#1a9e8f', fontSize: 28 }} />
                    <Typography variant="h5" fontWeight={700}>Online Admissions</Typography>
                </Box>
                <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Export All</Button>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} sm={3}>
                    <Card><CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">Total Applications</Typography>
                        <Typography variant="h4" fontWeight={700}>{applications.length}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ bgcolor: '#e8f5e9' }}><CardContent sx={{ textAlign: 'center' }}>
                        <CheckIcon sx={{ color: '#4caf50', fontSize: 28 }} />
                        <Typography variant="body2" color="text.secondary">Approved/Admitted</Typography>
                        <Typography variant="h4" fontWeight={700} color="success.main">{approvedCount}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ bgcolor: '#fff3e0' }}><CardContent sx={{ textAlign: 'center' }}>
                        <PendingIcon sx={{ color: '#ff9800', fontSize: 28 }} />
                        <Typography variant="body2" color="text.secondary">In Progress</Typography>
                        <Typography variant="h4" fontWeight={700} color="warning.main">{pendingCount}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card><CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">Conversion Rate</Typography>
                        <Typography variant="h4" fontWeight={700}>{applications.length > 0 ? Math.round((approvedCount / applications.length) * 100) : 0}%</Typography>
                        <LinearProgress variant="determinate" value={applications.length > 0 ? (approvedCount / applications.length) * 100 : 0}
                            sx={{ mt: 0.5, height: 4, borderRadius: 2 }} />
                    </CardContent></Card>
                </Grid>
            </Grid>

            <Card>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                    <Tab label={`All (${applications.length})`} />
                    <Tab label={`Approved (${approvedCount})`} />
                    <Tab label={`In Progress (${pendingCount})`} />
                    <Tab label={`Rejected (${rejectedCount})`} />
                </Tabs>
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" placeholder="Search by name or application number..." value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField fullWidth select size="small" label="Class" value={classFilter} onChange={(e) => setClassFilter(e.target.value)}>
                                <MenuItem value="">All</MenuItem>
                                {[...new Set(applications.map(a => a.class))].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                            </TextField>
                        </Grid>
                    </Grid>

                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 700 }}>App No.</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Parent</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Phone</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Class</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Applied</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Progress</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredApps.map(a => (
                                    <TableRow key={a.id} hover>
                                        <TableCell sx={{ fontWeight: 600 }}>{a.appNo}</TableCell>
                                        <TableCell>{a.studentName}</TableCell>
                                        <TableCell>{a.parentName}</TableCell>
                                        <TableCell>{a.phone}</TableCell>
                                        <TableCell>{a.class}</TableCell>
                                        <TableCell><Chip label={a.category} size="small" variant="outlined" /></TableCell>
                                        <TableCell>{new Date(a.appliedDate).toLocaleDateString()}</TableCell>
                                        <TableCell sx={{ minWidth: 100 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <LinearProgress variant="determinate" value={(a.step / 5) * 100}
                                                    sx={{
                                                        flexGrow: 1, height: 6, borderRadius: 3, bgcolor: '#e0e0e0',
                                                        '& .MuiLinearProgress-bar': { bgcolor: a.step >= 4 ? '#4caf50' : '#ff9800' }
                                                    }} />
                                                <Typography variant="caption">{a.step}/5</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell><Chip size="small" label={a.status} color={getStatusColor(a.status)} /></TableCell>
                                        <TableCell>
                                            <Button variant="outlined" size="small" onClick={() => { setSelectedApp(a); setViewDialog(true); }}>View</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>

            {/* Application Detail Dialog */}
            <Dialog open={viewDialog} onClose={() => setViewDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Application Details — {selectedApp?.appNo}</DialogTitle>
                <DialogContent>
                    {selectedApp && (
                        <>
                            <Stepper activeStep={selectedApp.step} alternativeLabel sx={{ my: 3 }}>
                                {admissionSteps.map(label => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
                            </Stepper>
                            <Divider sx={{ my: 2 }} />
                            <Grid container spacing={2}>
                                {[
                                    ['Student Name', selectedApp.studentName], ['Gender', selectedApp.gender],
                                    ['DOB', new Date(selectedApp.dob).toLocaleDateString()], ['Category', selectedApp.category],
                                    ['Parent Name', selectedApp.parentName], ['Phone', selectedApp.phone],
                                    ['Email', selectedApp.email], ['Class Applied', selectedApp.class],
                                    ['Previous School', selectedApp.previousSchool || '-'], ['Applied On', new Date(selectedApp.appliedDate).toLocaleDateString()],
                                ].map(([label, val]) => (
                                    <Grid item xs={6} sm={4} key={label}><Typography variant="body2" color="text.secondary">{label}</Typography><Typography fontWeight={600}>{val}</Typography></Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Typography variant="body2" color="text.secondary" gutterBottom>Documents Uploaded</Typography>
                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                        {selectedApp.documents?.length > 0 ? selectedApp.documents.map(d => <Chip key={d} label={d} size="small" icon={<CheckIcon />} color="success" />) : <Typography variant="body2" color="text.secondary">No documents uploaded</Typography>}
                                    </Box>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setViewDialog(false)}>Close</Button>
                    {selectedApp?.status !== 'Rejected' && selectedApp?.status !== 'Admitted' && (
                        <>
                            <Button variant="outlined" color="error" onClick={() => { toast.info('Application rejected'); setViewDialog(false); }}>Reject</Button>
                            <Button variant="contained" color="success" onClick={() => { toast.success('Application approved'); setViewDialog(false); }}>Approve</Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default OnlineAdmission;
